import styled, { css } from 'react-emotion';

import IconButton from '@material-ui/core/IconButton';
import BaseCloseIcon from '@material-ui/icons/Close';

import { theme } from '@ublend-npm/aulaui-next';

export const toastContainer = css`
  bottom: 36px;
  max-width: 584px;
`;

export const messageContainer = css`
  margin-left: 16px;
`;

export const toastContent = css`
  flex: 1;
  align-items: center;
  padding: 8px;
  background: ${theme.color.designSystem.grey90};

  .toastMessage {
    flex: 1 1;
    padding: 0px;
    font-size: ${theme.font.size.copy};
    font-family: ${theme.font.family.workSans};
  }

  .toastAction {
    font-size: ${theme.font.size.copy};
  }
`;

export const Message = styled('span')`
  display: flex;
  align-items: center;
`;

export const EmojiContainer = styled('div')`
  border-radius: 50%;
  font-size: ${theme.font.size.headline};
  height: 36px;
  min-width: 36px;
  line-height: 36px;
  text-align: center;
  background-color: hsla(0, 0%, 100%, 0.1);
  margin-left: 8px;
`;

export const DismissButton = styled(IconButton)`
  font-size: ${theme.font.size.copy};
  font-weight: ${theme.font.weight.semiBold};
  line-height: ${theme.font.size.copy};
  margin-right: 8px;
  color: #d4bbff;
  :hover {
    background: none;
    opacity: 0.5;
    transition: opacity 0.15s ease-in;
  }
`;

export const CloseIcon = styled(BaseCloseIcon)`
  font-size: 20px;
`;
